import React from "react";
import { IcoCloudUp } from "./Icons";

export default function UploadProgress({ progress, speed, eta }) {
  const percent = Math.max(0, Math.min(100, Number(progress) || 0));

  return (
    <div className="modal" role="status" aria-live="polite">
      <div className="modal-card upload-card">
        <span className="upload-ico"><IcoCloudUp size={26} /></span>
        <h3>Đang tải lên…</h3>
        <p>Vui lòng giữ nguyên trang cho tới khi hoàn tất.</p>

        <div className="progress">
          <div className="progress-fill" style={{ width: `${percent}%` }} />
        </div>

        <div className="upload-stats">
          <div>
            <span>Tiến độ</span>
            <strong>{percent.toFixed(0)}%</strong>
          </div>
          <div>
            <span>Tốc độ</span>
            <strong>{speed} MB/s</strong>
          </div>
          <div>
            <span>Còn lại</span>
            <strong>{eta}s</strong>
          </div>
        </div>
      </div>
    </div>
  );
}
